import { ConfigProvider, Radio, Row } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import Table, { ColumnsType } from "antd/lib/table";
import {  useState } from "react";
import {
   getVersionHistory,
} from '../../../api/api';
import Spinner from "../../../components/_common/Spinner";
import { errorNotify } from "../../../services/toast.notification";

const VersionHistory = () => {

  const columns: ColumnsType<any> = [
    { title: 'آزمایشگاه', dataIndex: 'str_LabPersianName' },
    { title: 'کاربر', dataIndex: 'str_FullName' },
    { title: 'از', dataIndex: 'str_VersionFrom' },
    { title: 'به', dataIndex: 'str_VersionTo' },
    { title: 'بانک', dataIndex: 'str_DataBaseName' },
    { title: 'زمان', dataIndex: 'str_LogDateTime' },
    { title: 'نام سیستم', dataIndex: 'str_ComputerName' },
    { title: 'تایید کننده', dataIndex: 'str_Confermer' },
    { title: 'توضیحات', dataIndex: 'Str_Description' },
  ];

  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const [firstDate, setFirstDate] = useState<any>();
  const [lastDate, setLastDate] = useState<any>();
  const [state, setState] = useState(1);

  /* ======================= API CALLS ======================= */

  const _getVersionHistory = (from: string, to: string, st: number) => {
    setIsLoading(true);

    getVersionHistory(from, to, st)
      .then((res: any) => {

 
        setData(res.data);
        setFilteredData(res.data);

          setIsLoading(false);
      })
      .catch(err => {
        setIsLoading(false);
        errorNotify(err.response?.data?.errorMessage);
      });
  };



  /* ======================= HANDLERS ======================= */

  const onChangeDatePicker = (dates: any, dateStrings: any) => {
    if (!dates || dateStrings.some((d: string) => !d)) return;

    setFirstDate(dates[0]);
    setLastDate(dates[1]);

    _getVersionHistory(
      dates[0].format('YYYY/MM/DD'),
      dates[1].format('YYYY/MM/DD'),
      state
    );
  };

  const onChangeStateRadio = (e: any) => {
    setState(e.target.value);
    if (firstDate && lastDate) {
      _getVersionHistory(firstDate.format('YYYY/MM/DD'), lastDate.format('YYYY/MM/DD'), e.target.value);
    }
  };


  return (
    <div className="tab-content-padding">

      <center style={{ paddingTop: 15 }}>
        <ConfigProvider locale={fa_IR} direction="rtl">
          <JalaliLocaleListener />
          <DatePickerJalali.RangePicker
            value={[firstDate, lastDate]}
            onCalendarChange={onChangeDatePicker}
          />
        </ConfigProvider>

        <Radio.Group onChange={onChangeStateRadio} value={state}>
          <Radio value={1}>موفق</Radio>
          <Radio value={0}>ناموفق</Radio>
        </Radio.Group>
      </center>

      {isLoading && <Spinner />}

      {!isLoading && (
        <>
          {data.length > 0 && (
            <>
            
              <Table
                rowKey="Prk_LabVersionLog_AutoID"
                scroll={{ x: 1500 }}
                dataSource={filteredData}
                columns={columns}
              />
            </>
          )}

          {filteredData.length === 0 && (
            <p className="empty-data">داده‌ای برای نمایش موجود نیست.</p>
          )}
        </>
      )}
    </div>
  );
};

export default VersionHistory;
